import React, { useState, useEffect, useCallback } from 'react';
import {  Drawer } from 'antd';
import FilterSelect from "components/Form/filterSelect"
import FilterInput from 'components/Form/filterInput';
import {  useSelector } from 'react-redux';
import { Button } from 'components/Button';


const SalaryFilterDrawer = ({   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {    
    userList, userListLoading,
   
} = useSelector((state) => state.common);

const [userOption, setUserOption] = useState([]);


useEffect(()=>{
    let _userList = []
    let _users = _userList.map(item=> {
        return{
            label: item.first_name,
            value: item.user_id
        }
    })    
    setUserOption(_users)   
},[])



const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    console.log(key,"000000setinput vlauuu", ...filters)
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}>

<div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>     

        <div className='col-12 mb-3' >
          <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "user")}} optionLabel={"label"} optionValue={'value'} options={userOption}  value={setFilterValue("user")} placeholder={"Select User"}/>
        </div>

        <div className='col-12 mb-3' >
       
          <FilterInput  
             defaultValue={setInputValue("email")} 
              onChange={e=>{handleInputChange(e.target.value, "email", true)}} 
              id="email"
              label={"Email"}
            />

        </div>        

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>     
        </div>

      </Drawer>
    </>
  );
};
export default SalaryFilterDrawer;